import * as z from "zod";

export const undoIntelligentInventoryOperation = {
  name: "undoIntelligentInventoryOperation" as const,
  input: z.object({
    toolCallId: z.string(),
    scope: z.enum(["clean-only", "all"]),
  }),
  output: z.object({ undoneCount: z.number(), skippedCount: z.number() }),
};
